/* eslint-disable react/no-unknown-property */
/* eslint-disable max-lines */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/boolean-prop-naming */
/* eslint-disable react/forbid-prop-types */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';
import Popup from 'Component/Popup';
import ProductMeasurements from 'Component/ProductMeasurements';
import {
    ACCESSORIES_LABELS,
    APPAREL_LABELS,
    FOOTWEAR_LABELS,
    KIDS_CLOTHES_BLOCK_AR,
    KIDS_CLOTHES_BLOCK_UAE_EN,
    KIDS_FOOTWEAR_BLOCK_AR,
    KIDS_FOOTWEAR_BLOCK_UAE_EN,
    KIDS_LABELS,
    MEN_LABELS,
    MENS_CLOTHES_BLOCK_AR,
    MENS_CLOTHES_BLOCK_UAE_EN,
    MENS_FOOTWEAR_BLOCK_AR,
    MENS_FOOTWEAR_BLOCK_UAE_EN,
    SIZE_CHART_POPUP_ID,
    UNISEX_LABELS,
    WOMEN_LABELS,
    WOMENS_CLOTHES_BLOCK_AR,
    WOMENS_CLOTHES_BLOCK_UAE_EN,
    WOMENS_FOOTWEAR_BLOCK_AR,
    WOMENS_FOOTWEAR_BLOCK_UAE_EN
} from 'Component/SizeChartPopup/SizeChartPopup.config';
import Tab from 'Component/Tab';
import Tabs from 'Component/Tabs';
import BrowserDatabase from 'Util/BrowserDatabase';

import './SizeChartPopup.style';

/** @namespace Scandipwa/Component/SizeChartPopup/Component */
export class SizeChartPopupComponent extends PureComponent {
    static propTypes = {
        code: PropTypes.string.isRequired,
        product: PropTypes.object,
        parameters: PropTypes.objectOf(PropTypes.string),
        areDetailsLoaded: PropTypes.bool
    };

    static defaultProps = {
        product: {},
        parameters: {},
        areDetailsLoaded: false
    };

    state = {
        gender: null,
        division: null
    };

    componentDidUpdate(prevProps) {
        const { product: prevProduct } = prevProps;
        const { product } = this.props;
        const { gender, division } = this.state;

        if (product !== prevProduct || !gender || !division) {
            const productAttributes = BrowserDatabase.getItem('productAttributes');

            if (!productAttributes
                || Object.keys(product).length === 0
                || Object.keys(product.attributes).length === 0) {
                return;
            }

            const {
                product: {
                    gender: productGender,
                    attributes: {
                        product_division: {
                            attribute_options: productDivisionOptions
                        }
                    }
                }
            } = this.props;

            const { customAttributeMetadata: { items } } = productAttributes;
            const result = { gender: null, division: null };

            items.forEach((item) => {
                const { attribute_code } = item;

                if (attribute_code === 'gender') {
                    const { attribute_options } = item;

                    attribute_options.forEach(({ value, label }) => {
                        if (+value === +productGender) {
                            result.gender = label;
                            // eslint-disable-next-line no-useless-return
                            return;
                        }
                    });

                    // eslint-disable-next-line no-useless-return
                    return;
                }
            });

            result.division = Object.values(productDivisionOptions)[0].label;
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ gender: result.gender, division: result.division });
        }
    }

    isKids() {
        const { gender } = this.state;

        return KIDS_LABELS.includes(gender);
    }

    isMen() {
        const { gender } = this.state;

        return MEN_LABELS.includes(gender);
    }

    isWomen() {
        const { gender } = this.state;

        return WOMEN_LABELS.includes(gender);
    }

    isUnisex() {
        const { gender } = this.state;

        return UNISEX_LABELS.includes(gender);
    }

    isApparel() {
        const { division } = this.state;

        return APPAREL_LABELS.includes(division);
    }

    isFootwear() {
        const { division } = this.state;

        return FOOTWEAR_LABELS.includes(division);
    }

    isAccessories() {
        const { division } = this.state;

        return ACCESSORIES_LABELS.includes(division);
    }

    renderProductMeasurements() {
        const { product, parameters, areDetailsLoaded } = this.props;

        if (!product || !parameters || !areDetailsLoaded) {
            return null;
        }

        return (
            <ProductMeasurements
              product={ { ...product, parameters } }
              areDetailsLoaded={ areDetailsLoaded }
            />
        );
    }

    renderContent() {
        if (!this.isFootwear() && !this.isApparel()) {
            return null;
        }

        return (
            <Tabs htmlName="main-tabs" renderInactiveTabButtons>
                { (this.isKids() || this.isUnisex()) ? this.renderKidsTab() : null }
                { (this.isMen() || this.isUnisex()) ? this.renderMenTab() : null }
                { (this.isWomen() || this.isUnisex()) ? this.renderWomenTab() : null }
            </Tabs>
        );
    }

    renderKidsTab() {
        return (
            <Tab mix={ { block: 'SizeChartPopup', elem: 'KidsTabs' } } id="0" label={ __('KIDS') }>
                <Tabs>
                    { this.isFootwear() ? this.renderKidsFootwearTab() : null }
                    { this.isApparel() ? this.renderKidsClothingTab() : null }
                </Tabs>
            </Tab>
        );
    }

    renderKidsFootwearTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? KIDS_FOOTWEAR_BLOCK_UAE_EN : KIDS_FOOTWEAR_BLOCK_AR;

        return (
            <Tab id="kidsFootwear" label={ __('Footwear') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    renderKidsClothingTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? KIDS_CLOTHES_BLOCK_UAE_EN : KIDS_CLOTHES_BLOCK_AR;

        return (
            <Tab id="kidsClothing" label={ __('Clothing') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    renderMenTab() {
        return (
            <Tab mix={ { block: 'SizeChartPopup', elem: 'MenTabs' } } id="1" label={ __('MEN') }>
                <Tabs>
                    { this.isFootwear() ? this.renderMenFootwearTab() : null }
                    { this.isApparel() ? this.renderMenClothingTab() : null }
                </Tabs>
            </Tab>
        );
    }

    renderMenFootwearTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? MENS_FOOTWEAR_BLOCK_UAE_EN : MENS_FOOTWEAR_BLOCK_AR;

        return (
            <Tab id="menFootwear" label={ __('Footwear') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    renderMenClothingTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? MENS_CLOTHES_BLOCK_UAE_EN : MENS_CLOTHES_BLOCK_AR;

        return (
            <Tab id="menClothing" label={ __('Clothing') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    renderWomenTab() {
        return (
            <Tab mix={ { block: 'SizeChartPopup', elem: 'WomenTabs' } } id="2" label={ __('WOMEN') }>
                <Tabs>
                    { this.isFootwear() ? this.renderWomenFootwearTab() : null }
                    { this.isApparel() ? this.renderWomenClothingTab() : null }
                </Tabs>
            </Tab>
        );
    }

    renderWomenFootwearTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? WOMENS_FOOTWEAR_BLOCK_UAE_EN : WOMENS_FOOTWEAR_BLOCK_AR;

        return (
            <Tab id="womenFootwear" label={ __('Footwear') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    renderWomenClothingTab() {
        const { code } = this.props;

        if (!code) {
            return null;
        }

        // PumaPWA UAE only
        const identifier = code.includes('en') ? WOMENS_CLOTHES_BLOCK_UAE_EN : WOMENS_CLOTHES_BLOCK_AR;

        return (
            <Tab id="womenclothing" label={ __('Clothing') }>
                <CmsBlock identifier={ identifier } />
            </Tab>
        );
    }

    render() {
        return (
            <Popup
              id={ SIZE_CHART_POPUP_ID }
              mix={ { block: 'SizeChartPopup' } }
            >
                <div
                  block="SizeChartPopup"
                  elem="Content"
                >
                    { this.renderContent() }
                </div>
                { this.renderProductMeasurements() }
            </Popup>
        );
    }
}

export default SizeChartPopupComponent;
